import React, { Component } from 'react';
import { round } from 'mathjs';
import currencyFormatter from 'currency-formatter';
import moment from 'moment-timezone';

class KucoinCreditBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sort: 'timestamp_ago',
      asc: 1,
      collapse: 'expand',
    };
  }

  rendeCurrency(currency) {
    let color = 'blue';
    if (currency == 'UST') {
      color = 'red';
      currency = 'USDT';
    } else if (currency == 'USD') {
      color = 'black';
    }
    return <span className={'badge bg-' + color}>{currency}</span>;
  }

  renderStatus(data) {
    if (
      data.timestamp * 1000 + data.period * 24 * 60 * 60 * 1000 >=
      Date.now()
    ) {
      return <span className="label label-success">{data.pair}</span>;
    } else {
      return <span className="label label-danger">清算中</span>;
    }
  }

  renderRow(data) {
    console.log(data);
    var rows = [];
    data
      .sort((a, b) => {
        return a[this.state.sort] > b[this.state.sort]
          ? 1 * this.state.asc
          : -1 * this.state.asc;
      })
      .forEach((item, index) => {
        if (this.state.collapse == 'expand' && index > 9) {
          return true;
        }
        rows.push(
          <tr key={'r' + index}>
            <td style={{ textAlign: 'center' }}>{index + 1}</td>
            <td style={{ textAlign: 'center' }}>
              {this.rendeCurrency(item.currency)}
            </td>
            <td style={{ textAlign: 'right' }}>
              {currencyFormatter.format(item.amount, { code: 'USD' })}
            </td>
            <td style={{ textAlign: 'right' }}>
              {currencyFormatter.format(item.rate, { code: 'USD', symbol: '' })}
              %
            </td>
            <td style={{ textAlign: 'center' }}>
              {item.ago} / {item.period}天
            </td>
            <td style={{ textAlign: 'center' }}>
              {moment
                .utc(item.timestamp * 1000)
                .tz('Asia/Taipei')
                .format('YYYY-MM-DD HH:mm')}
            </td>
          </tr>
        );
      });
    return rows;
  }
  render() {
    let data = JSON.parse(this.props.data);
    return (
      <div className="box box-warning">
        <div className="box-header with-border">
          <h3 className="box-title">
            放款狀態{' '}
            <span className="badge bg-green">
              {currencyFormatter.format(this.props.credit_total, { code: 'USD' })}
            </span>{' '}
            <span className="badge bg-red">{round(this.props.credit_rate, 2)}%</span>
          </h3>
          <div className="box-tools pull-right">
            <a
              href="#"
              style={{ color: '#fff', fontSize: 20 }}
              onClick={e => {
                e.preventDefault();
                if (this.state.collapse == 'expand') {
                  this.setState({ collapse: 'compress' });
                } else {
                  this.setState({ collapse: 'expand' });
                }
              }}
            >
              <i
                className={
                  'fa fa-' +
                  (this.state.collapse == 'expand'
                    ? 'chevron-down'
                    : 'chevron-up')
                }
              ></i>
            </a>
          </div>
        </div>
        <div className="box-body">
          <div className="table-responsive">
            <table className="table no-margin table-striped">
              <thead>
                <tr>
                  <th width="50" style={{ textAlign: 'center' }}>
                    no.
                  </th>
                  <th
                    width="65"
                    style={{ textAlign: 'center', cursor: 'pointer' }}
                    onClick={() => {
                      this.setState({
                        sort: 'currency',
                        asc: this.state.asc * -1,
                      });
                    }}
                  >
                    幣種<i className="fa fa-fw fa-sort"></i>
                  </th>
                  <th
                    style={{ textAlign: 'center', cursor: 'pointer' }}
                    onClick={() => {
                      this.setState({
                        sort: 'amount',
                        asc: this.state.asc * -1,
                      });
                    }}
                  >
                    金額<i className="fa fa-fw fa-sort"></i>
                  </th>
                  <th
                    style={{ textAlign: 'center', cursor: 'pointer' }}
                    onClick={() => {
                      this.setState({
                        sort: 'rate',
                        asc: this.state.asc * -1,
                      });
                    }}
                  >
                    利率<i className="fa fa-fw fa-sort"></i>
                  </th>
                  <th
                    style={{ textAlign: 'center', cursor: 'pointer' }}
                    onClick={() => {
                      this.setState({
                        sort: 'timestamp_ago',
                        asc: this.state.asc * -1,
                      });
                    }}
                  >
                    期間<i className="fa fa-fw fa-sort"></i>
                  </th>
                  <th
                    style={{ textAlign: 'center', cursor: 'pointer' }}
                    onClick={() => {
                      this.setState({
                        sort: 'timestamp',
                        asc: this.state.asc * -1,
                      });
                    }}
                  >
                    到期日<i className="fa fa-fw fa-sort"></i>
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderRow(data)}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
export default KucoinCreditBox;
